<!-- @format -->
<template>
	<div class="pcp-header-home">
		<el-icon>
			<home-filled @click="goHome" />
		</el-icon>
	</div>
</template>

<script setup lang="ts">
	import { getEnvUrlByUrl } from '@power/runtime-vue3';

	const goHome = () => {
		const homeUrl = getEnvUrlByUrl(`/powerportal/workbench`);
		console.log('homeUrl', homeUrl);
		window.location.href = homeUrl;
	};
</script>

<style lang="scss" scoped>
	.pcp-header-home {
		cursor: pointer;
		display: flex;
	}
</style>
